import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const useAlert = () => {
  const navigate = useNavigate();

  const showSuccessAlert = () => {
    Swal.fire({
      title: 'Başarılı Giriş',
      text: 'Başarılı Giriş',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      navigate("/");
    });
  };

  const showErrorAlert = () => {
    Swal.fire({
      title: 'Başarısız Giriş',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessAlertSignUp = () => {
    Swal.fire({
      title: 'Başarılı Kayıt',
      text: 'Başarılı Kayıt',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      navigate("/");
    });
  };

  const showErrorAlertSignUp = () => {
    Swal.fire({
      title: 'Başarısız Kayıt',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessProfileUpdate = () => {
    Swal.fire({
      title: 'Başarılı Güncelleme',
      text: 'Başarılı Güncelleme',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
    });
  };

  const showErrorAlertProfileUpdate = () => {
    Swal.fire({
      title: 'Başarısız Güncelleme',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };


  const showSuccessCompany = () => {
    Swal.fire({
      title: 'Kaydedildi ',
      text: 'Kaydedildi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
    });
  };

  const showErrorAlertCompany = () => {
    Swal.fire({
      title: 'Kaydedilemedi',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };



  const showSuccessPasswordCode = () => {
    Swal.fire({
      title: 'Kod Gönderildi ',
      text: 'Başarılı ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
    });
  };

  const showErrorAlertPasswordCode = () => {
    Swal.fire({
      title: 'Kod Gönderilemedi',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };


  const showSuccessChangePassword = () => {
    Swal.fire({
      title: 'Şifre değiştirildi ',
      text: 'Değiştirildi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
    });
  };

  const showErrorAlertChangePassword = () => {
    Swal.fire({
      title: 'Şifre Değiştirilemedi',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessAddInvoices = () => {
    Swal.fire({
      title: 'Fatura Oluşturuldu',
      text: 'Oluşturuldu ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
    });
  };

  const showErrorAlertAddInvoices = () => {
    Swal.fire({
      title: 'Fatura Oluşturulamadı',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessAddInvoicesCustomer = () => {
    Swal.fire({
      title: 'Müşteri Oluşturuldu',
      text: 'Oluşturuldu ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
    });
  };

  const showErrorAlertAddInvoicesCustomer = () => {
    Swal.fire({
      title: 'Müşteri Oluşturulamadı',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessUpdateInvoices = () => {
    Swal.fire({
      title: 'Fatura Güncellendi',
      text: 'Güncellendi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
    });
  };

  const showErrorAlertUpdateInvoices = () => {
    Swal.fire({
      title: 'Fatura Güncellenemedi',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };


  const showSuccessUpdateAddress = () => {
    Swal.fire({
      title: 'Adres Güncellendi',
      text: 'Güncellendi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
    });
  };

  const showErrorAlertUpdateAddress = () => {
    Swal.fire({
      title: 'Adres Güncellenemedi',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };


  const showSuccessAddAddress = () => {
    Swal.fire({
      title: 'Adres Eklendi',
      text: 'Eklendi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
    });
  };

  const showErrorAlertAddAddress = () => {
    Swal.fire({
      title: 'Adres Eklenemedi',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessAddressDelete = () => {
    Swal.fire({
      title: 'Adres Silindi',
      text: 'Silindi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
    });
  };

  const showErrorAlertAddressDelete = () => {
    Swal.fire({
      title: 'Adres Silinemedi',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };


  const showSuccessMarketPlaceAccountAdd = () => {
    Swal.fire({
      title: 'Bilgiler kayıtedildi',
      text: 'kayıtedildi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
  
    })
  };

  const showErrorAlertMarketPlaceAccountAdd = () => {
    Swal.fire({
      title: 'Kayıt başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessMarketPlaceAccountUpdate = () => {
    Swal.fire({
      title: 'Bilgiler Güncellendi',
      text: 'Güncellendi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
  
    })
  };

  const showErrorAlertMarketPlaceAccountUpdate = () => {
    Swal.fire({
      title: 'Güncelleme başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessEcommercePlaceAccountUpdate = () => {
    Swal.fire({
      title: 'Bilgiler Güncellendi',
      text: 'Güncellendi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
  
    })
  };

  const showErrorAlertEcommercePlaceAccountUpdate = () => {
    Swal.fire({
      title: 'Güncelleme başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessEcommercePlaceAccountAdd = () => {
    Swal.fire({
      title: 'Bilgiler kayıtedildi',
      text: 'kayıtedildi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
  
    })
  };

  const showErrorAlertEcommercePlaceAccountAdd = () => {
    Swal.fire({
      title: 'Kayıt başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };


  
  const showSuccessInvoiceIntegratorAccountUpdate = () => {
    Swal.fire({
      title: 'Bilgiler Güncellendi',
      text: 'Güncellendi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
  
    })
  };

  const showErrorAlertInvoiceIntegratorAccountUpdate = () => {
    Swal.fire({
      title: 'Güncelleme başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessInvoiceIntegratorAccountAdd = () => {
    Swal.fire({
      title: 'Bilgiler kayıtedildi',
      text: 'kayıtedildi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
  
    })
  };

  const showErrorAlertInvoiceIntegratorAccountAdd = () => {
    Swal.fire({
      title: 'Kayıt başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };
  // Ürün Ekleme Başarılı Uyarısı
  const showSuccessProductAdded = () => {
    Swal.fire({
      title: 'Ürün Eklendi',
      text: 'Ürün başarıyla eklendi.',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();

    });
  };

  // Ürün Ekleme Başarısız Uyarısı
  const showErrorProductAdded = () => {
    Swal.fire({
      title: 'Ürün Eklenemedi',
      text: 'Ürün eklenirken bir hata oluştu. Lütfen tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };


  // Ürün Ekleme Başarılı Uyarısı
  const showSuccessBrandAdded = () => {
    Swal.fire({
      title: 'Marka Eklendi',
      text: 'Marka başarıyla eklendi.',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();

    });
  };

  // Ürün Ekleme Başarısız Uyarısı
  const showErrorBrandAdded = () => {
    Swal.fire({
      title: 'Marka Eklenemedi',
      text: 'Marka eklenirken bir hata oluştu. Lütfen tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };




  const showSuccessBrandDelete = () => {
    Swal.fire({
      title: 'Marka Silindi',
      text: 'Silindi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
    });
  };

  const showErrorAlertBrandDelete = () => {
    Swal.fire({
      title: 'Marka Silinemedi',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };


  const showErrorAlertCategoryUpdate = () => {
    Swal.fire({
      title: 'Güncelleme başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessAlertCategoryUpdate = () => {
    Swal.fire({
      title: 'Bilgiler Güncellendi',
      text: 'Güncellendi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
    });
  };


  const showErrorAlertCategoryAdd = () => {
    Swal.fire({
      title: 'İşlem başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessAlertCategoryAdd = () => {
    Swal.fire({
      title: 'Kategori Eklendi',
      text: 'Eklendi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
    });
  };

  const showErrorAlertExcelAdd = () => {
    Swal.fire({
      title: 'İşlem başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessAlertexcelAdd = () => {
    Swal.fire({
      title: 'Excel Eklendi',
      text: 'Eklendi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
    });
  };

  const showErrorAlertXMLAdd = () => {
    Swal.fire({
      title: 'İşlem başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessAlertXMLAdd = () => {
    Swal.fire({
      title: 'XML Eklendi',
      text: 'Eklendi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      navigate("/XmlProductSource");
    });
  };


  const showErrorAlertCategoryVariantAdd = () => {
    Swal.fire({
      title: 'İşlem başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessAlertCategoryVariantAdd = () => {
    Swal.fire({
      title: 'Kategori Varyantı Eklendi',
      text: 'Eklendi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
    });
  };

  const showErrorAlertCategoryVariantDelete = () => {
    Swal.fire({
      title: 'İşlem başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessAlertCategoryVariantDelete = () => {
    Swal.fire({
      title: 'Kategori Varyantı Silindi',
      text: 'Silindi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
    });
  };



  const showErrorAlertProductSend = () => {
    Swal.fire({
      title: 'İşlem başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessAlertProductSend = () => {
    Swal.fire({
      title: 'İşlem Tamamlandı',
      text: 'Eklendi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    })
  };


  const showErrorAlertMarketpleaceBrand = () => {
    Swal.fire({
      title: 'İşlem başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };
    const showErrorAlertBulkPrice = () => {
    Swal.fire({
      title: 'İşlem başarısız',
      text: 'Devam eden işleminiz bulunuyor.Bittiğinde tekrar oluşturun.',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };
    const showSuccessAlertBulkPrice = () => {
    Swal.fire({
      title: 'İşlem Tamamlandı',
      text: 'Kaydedildi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    })
  };

  const showSuccessAlertMarketpleaceBrand = () => {
    Swal.fire({
      title: 'İşlem Tamamlandı',
      text: 'Kaydedildi ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    })
  };

  const showSuccessAlertPayment = () => {
    Swal.fire({
      title: 'Ödeme başarılı',
      text: 'Başarılı ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      navigate("/");
    });
  };



  const showErrorAlertAll = () => {
    Swal.fire({
      title: 'İşlem başarısız',
      text: 'Tekrar deneyiniz!',
      icon: 'error',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    });
  };

  const showSuccessAlertAll = () => {
    Swal.fire({
      title: 'İşlem Tamamlandı',
      text: 'Tamamlandı ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
  
    })
  };

  const showSuccessAlertAllNoReload = () => {
    Swal.fire({
      title: 'İşlem Tamamlandı',
      text: 'Tamamlandı ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    })
  };





  const showSuccessAlertDeleteProduct = () => {
    Swal.fire({
      title: 'Ürün Silme Başarılı ',
      text: 'Başarılı ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
    });
  };


  const showSuccessAlertInvoice = () => {
    Swal.fire({
      title: 'Fatura Silme Başarılı ',
      text: 'Başarılı ',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      position: 'center',
      customClass: {
        popup: 'swal-popup',
      },
    }).then(() => {
      window.location.reload();
    });
  };
  
  return {
    showSuccessAlertDeleteProduct,
    showSuccessAlertAllNoReload,
    showSuccessAlertAll,
    showErrorAlertAll,
    showSuccessAlertPayment,
    showSuccessAlertMarketpleaceBrand,
    showErrorAlertMarketpleaceBrand,
    showSuccessAlertProductSend,
    showErrorAlertProductSend,
    showSuccessAlertCategoryVariantDelete,
    showErrorAlertCategoryVariantDelete,
    showSuccessAlertCategoryVariantAdd,
    showErrorAlertCategoryVariantAdd,
    showSuccessAlertXMLAdd,
    showErrorAlertXMLAdd,
    showSuccessAlertexcelAdd,
    showErrorAlertExcelAdd,
    showErrorAlertCategoryAdd,
    showSuccessAlertCategoryAdd,
    showSuccessAlertCategoryUpdate,
    showErrorAlertCategoryUpdate,
    showErrorAlertBrandDelete,
    showSuccessBrandDelete,
    showErrorBrandAdded,
    showSuccessBrandAdded,
    showSuccessAlert,
    showErrorAlert,
    showSuccessAlertSignUp,
    showErrorAlertSignUp,
    showSuccessProfileUpdate,
    showErrorAlertProfileUpdate,
    showSuccessCompany,
    showErrorAlertCompany,
    showErrorAlertChangePassword,
    showSuccessChangePassword, showErrorAlertPasswordCode,
    showSuccessPasswordCode,
    showSuccessAddInvoices,
    showErrorAlertAddInvoices,
    showSuccessAddInvoicesCustomer,
    showErrorAlertAddInvoicesCustomer,
    showSuccessUpdateInvoices,
    showErrorAlertUpdateInvoices,
    showSuccessUpdateAddress,
    showErrorAlertUpdateAddress,
    showSuccessAddAddress,
    showErrorAlertAddAddress,
    showSuccessAddressDelete,
    showErrorAlertAddressDelete,
    showSuccessMarketPlaceAccountAdd,
    showErrorAlertMarketPlaceAccountAdd,
    showErrorAlertMarketPlaceAccountUpdate,
    showSuccessMarketPlaceAccountUpdate,
    showSuccessProductAdded,
    showErrorProductAdded,
    showSuccessEcommercePlaceAccountUpdate,
    showErrorAlertEcommercePlaceAccountUpdate,
    showSuccessEcommercePlaceAccountAdd,
    showErrorAlertEcommercePlaceAccountAdd,
    showSuccessInvoiceIntegratorAccountUpdate,
    showErrorAlertInvoiceIntegratorAccountUpdate,
    showSuccessInvoiceIntegratorAccountAdd,
    showErrorAlertInvoiceIntegratorAccountAdd,
    showSuccessAlertInvoice,
    showErrorAlertBulkPrice,
    showSuccessAlertBulkPrice
  };
};

export default useAlert;
